import React from 'react';
import Card from './Card';
import {Button,Grid,TextField} from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save'

const Form = ({ inputText, setInputText, note, setNote }) => {
    const inputHandler = e =>{
        setInputText(e.target.value);
    };
    const submitHandler = e =>{
        e.preventDefault();
        setNote([
            ...note,
            {text:inputText, id:Math.random()*1000}
        ]);
        setInputText('');
    }
    return(
    <form>
        <TextField value={inputText} id="outlined-basic" label="New Note" onChange={inputHandler} variant="outlined" />
        <Button startIcon={<SaveIcon/>} variant="outlined" onClick={submitHandler} size="large" >Save</Button>
    </form>
    );
}

export default Form;